// Config de runtime do front (T07 §3.8): vem só de /config.js (gerado pelo container do nginx).
export interface AppConfig {
    appMode: 'production' | 'staging' | 'development';
}

declare global {
    interface Window {
        __APP_CONFIG__?: AppConfig;
    }
}

const MODOS: readonly AppConfig['appMode'][] = ['production', 'staging', 'development'];

/** Falha fechada: sem /config.js ou com `appMode` desconhecido, o app se comporta como produção. */
export const appConfig: AppConfig = {
    appMode: MODOS.find((m) => m === window.__APP_CONFIG__?.appMode) ?? 'production',
};
